import ExclamationMarkIcon from '@/lib/assets/mark.svg';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import CheckIcon from '@/lib/assets/check.svg';
import BackLink from '../BackLink';
import AdyenDonation from '../AdyenDonation';

import styles from './CallbackPaymentBlock.module.scss';

const FIVE_SECONDS = 5 * 1000;
const FIFTEEN_SECONDS = 15 * 1000;

const CallbackPaymentBlock = ({
    isPaymentSuccess,
    redirectURL,
    isTimeUp,
    isCheckoutPlan = false,
    donationEnabled,
    shouldRedirect,
    setShouldRedirect,
    lyriaUrl,
    paymentRequestId,
    locale = '',
}) => {
    const [displayDonation, setDisplayDonation] = React.useState(false);
    const [donationFinished, setDonationFinished] = React.useState(false);
    const [donationSuccess, setDonationSuccess] = React.useState(false);

    const { t } = useTranslation();

    React.useEffect(() => {
        setDisplayDonation(donationEnabled);
    }, [donationEnabled]);

    const onClickRedirect = useCallback(
        () => {
            if (isCheckoutPlan) {
                const url = new URL(redirectURL);
                url.searchParams.set('redirect', 'true');
                window.location.assign(url.toString());
            } else {
                window.location.assign(redirectURL);
            }
            
        },
        [isCheckoutPlan, redirectURL],
    );
    const delay = isPaymentSuccess && (!displayDonation || donationSuccess) ? FIVE_SECONDS : FIFTEEN_SECONDS;

    React.useEffect(() => {
        if (shouldRedirect) {
            setTimeout(
                () => {
                    onClickRedirect();
                },
                delay,
            );
        }
    }, [shouldRedirect, delay, onClickRedirect]);

    return (
        <div className={styles.container}>
            {!isPaymentSuccess && isCheckoutPlan && (
                <BackLink />
            )}
            {isPaymentSuccess
                ? (
                    <>
                        {donationFinished ? (
                            <>
                                {donationSuccess ? (<CheckIcon alt='check icon' />) : ( <div className={styles.semiSuccess}><ExclamationMarkIcon ></ExclamationMarkIcon></div> )}
                                <div className={styles.title}>
                                    {t(donationSuccess ? 'donationSuccess' : 'donationFailure')}
                                </div>
                            </>
                        ) : (
                            <>
                                <CheckIcon alt='check icon' />
                                <div className={styles.title}>{t('callbackValidatedPayment')}</div>
                            </>
                        )}
                        {displayDonation && !donationFinished &&
                            <AdyenDonation
                                isPaymentSuccess={isPaymentSuccess}
                                locale={locale}
                                lyriaUrl={lyriaUrl}
                                paymentRequestId={paymentRequestId}
                                donationEnabled={donationEnabled}
                                shouldRedirect={shouldRedirect}
                                setShouldRedirect={setShouldRedirect}
                                displayDonation={displayDonation}
                                setDisplayDonation={setDisplayDonation}
                                setDonationSuccess={setDonationSuccess}
                                setDonationFinished={setDonationFinished}
                            />
                        }

                    </>
                )
                :
                (
                    <div>{isTimeUp ? t('order_expired') : t('callbackFailedPayment')}</div>
                )}
            {redirectURL && shouldRedirect &&
                <>
                    <button className={styles.button} onClick={onClickRedirect}>{t('callbackCTA')}</button>
                    <p className={styles.footer}>{t('callbackFooter', { count: delay/1000 })}</p>
                </>
            }
        </div>
    );
};

CallbackPaymentBlock.propTypes = {
    isPaymentSuccess: PropTypes.bool,
    redirectURL: PropTypes.string,
    isTimeUp: PropTypes.bool,
    isCheckoutPlan: PropTypes.bool,
    paymentRequestId: PropTypes.string,
};

export default CallbackPaymentBlock;
